import { Navigate, Outlet, useOutletContext } from 'react-router-dom'

import { DocumentsEmployeeRootPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/documents/lib/EmployeesCollectionsBootstrap'
import type { RouteContext } from 'modules/employees/lib/types'

const isAuthorized = (
  employeeCanSeeDocuments: boolean,
  userCanManageAnyEmployeeFolder: boolean,
  canSeeAnyEmployeeDocumentsFolderForEmployee: boolean,
  canSeeEmployeeDocumentsWithoutFolder: boolean
): boolean => {
  return (
    employeeCanSeeDocuments ||
    userCanManageAnyEmployeeFolder ||
    canSeeAnyEmployeeDocumentsFolderForEmployee ||
    canSeeEmployeeDocumentsWithoutFolder
  )
}

const Container = () => {
  const { navigation } = useNavigation()
  const context = useOutletContext<RouteContext>()
  const { employeeId } = context

  const { data, loading } = useQuery(DocumentsEmployeeRootPageDocument, {
    variables: {
      employeeId: employeeId ?? 0,
    },
    skip: !employeeId,
  })

  if (loading) {
    return <Loading />
  }

  const employeeCanSeeDocuments =
    data?.employees.employeesConnection.edges[0]?.node?._policies?.seeDocuments.can ?? false
  const canSeeAnyEmployeeDocumentsFolderForEmployee =
    data?.employees.employeesConnection.edges[0]?.node?._policies?.seeAnyEmployeeDocumentsByFolder
      ?.can ?? false
  const canSeeEmployeeDocumentsWithoutFolder =
    data?.employees.employeesConnection.edges[0]?.node?._policies?.seeEmployeeDocumentsWithoutFolder
      ?.can ?? false
  const userCanManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can ?? false

  if (
    !!employeeId &&
    !isAuthorized(
      employeeCanSeeDocuments,
      userCanManageAnyEmployeeFolder,
      canSeeAnyEmployeeDocumentsFolderForEmployee,
      canSeeEmployeeDocumentsWithoutFolder
    )
  ) {
    return <Navigate replace to={navigation.employees.id.fullPath({ id: employeeId })} />
  }

  return <Outlet context={context} />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
